import _asyncToGenerator from "/Users/adway/Documents/agora.io/ad-manage-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { postRollback } from '@/api/adConfig';
import { formatTimestamp } from '@/utils/date';
import infoList from '@/mixins/infoList';
export default {
  name: 'AdConfig',
  filters: {
    timestampFormat: function timestampFormat(time) {
      return formatTimestamp(time);
    }
  },
  mixins: [infoList],
  data: function data() {
    return {};
  },
  created: function created() {
    this.getTableData();
  },
  methods: {
    rollback: function rollback(row) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.$confirm('确定执行此操作?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  var res;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return postRollback({
                            Project: row.projectName,
                            Env: row.env,
                            Cluster: row.cluster,
                            Id: row.id
                          });

                        case 2:
                          res = _context.sent;

                          if (res.code === 0) {
                            _this.$message({
                              type: 'success',
                              message: '操作成功!'
                            });

                            _this.getTableData();
                          }

                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};